// type_sco is lesson or course

// Object Assign polyfill for IE
if (!Object.assign) {
  Object.defineProperty(Object, 'assign', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(target) {
      'use strict';
      if (target === undefined || target === null) {
        throw new TypeError('Cannot convert first argument to object');
      }

      var to = Object(target);
      for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) {
          continue;
        }
        nextSource = Object(nextSource);

        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
      return to;
    }
  });
}

function ScormAPI(type_sco, lesson_id, scorm_data, callbacks) {
  var session = null;
  var lastError = "0";
  var log = new Log();
  var dataModel = Object.assign({}, scorm_data || { '': { 'value': 'not attempted', 'status': 0 }});
  callbacks.success(true);

  function runNativeCode(code) {
    var windowToPostTo = window.opener || window.parent;
    if (windowToPostTo) {
      windowToPostTo.postMessage(code, "*");
      window.postMessage(code, "*");
    } else {
      var iframe = document.createElement("IFRAME")
      var url    = "gap-code://" + window.escape(code)
      iframe.setAttribute("src", url)
      document.documentElement.appendChild(iframe)
      iframe.parentNode.removeChild(iframe)
      iframe = null
    }
  }

  function LMSInitialize(param) {
    log.i('LMSInitialize(' + param + '){ return "true" }');
    return "true";
  }

  function LMSGetErrorString() {
    log.i("LMSGetErrorString() { return \"ERROR\" }");
    return "ERROR";
  }

  function LMSGetLastError() {
    log.i('LMSGetLastError(){ return "' + lastError + '" }');
    return lastError;
  }

  function LMSGetValue(key) {
    var value = "";

    if(key in dataModel) {
      value = dataModel[key].value;
    }

    log.i('LMSGetValue(' + key + '){ return "' + value + '" }');
    return value;
  }

  function LMSSetValue(key, value) {
    var success = "true";
    key         = key || "";

    if (key.match(/cmi\.interactions/)) {
      existingValue = dataModel[key] && dataModel[key].value;
      if (!existingValue) {
        value = [ value ];
      } else {
        value = existingValue.concat([value]);
      }
    } 

    dataModel[key] = {
      'value': value,
      'status': 0
    };
    log.i('LMSSetValue(' + key + ', ' + value + '){ return "' + success + '" }');

    return success;
  }

  var commitStack = [];
  var commiting = false;
  var commitAttempts = 0;
  var commitMaxAttempts = 5;

  function LMSCommit(param) {
    commitStack.push(param);
    log.i('LMSCommit(' + param + '){ return "true" }');
    return "true";
  }

  function commitSync() {
    if(commiting == false && commitStack.length > 0) {
      commiting = true;
      var data = {};

      for(var i in dataModel) {
        if(dataModel[i].status == 0) {
          dataModel[i].status = 2;
          data[i] = dataModel[i];
        }
      }
    }

    setTimeout(commitSync, 500);
  }

  function commitSuccess(response) {
    var data = {};

    if (response.success == true) {
      for (var i in dataModel) {
        if (dataModel[i].status == 2) {
          dataModel[i].status = 1;
          data[i] = dataModel[i];
        }
      }
    } else {
      for (var i in dataModel) {
        if (dataModel[i].status == 2) {
          dataModel[i].status = 0;
          data[i] = dataModel[i];
        }
      }
    }

    commitStack.splice(0, 1);
    commiting = false;
    commitAttempts = 0;
  }

  function commitError() {
    for (var i in dataModel) {
      if (dataModel[i].status == 2) {
        dataModel[i].status = 0;
        data[i] = dataModel[i];
      }
    }

    commiting = false;

    if (commitAttempts > commitMaxAttempts) {
      commitAttempts = 0;
      commitStack.splice(0, 1);
    } else {
      commitAttempts++;
    }
  }

  var lmsFinishAlreadyCalled = false;

  function LMSFinish(param) {
    if (!lmsFinishAlreadyCalled) {
      window.SCORMED.LMSFinish(Base64.encode(JSON.stringify(dataModel)))
      lmsFinishAlreadyCalled = true;
    }
    return "true";
  }

  // Log
  function Log() {
    var enabled = false;

    function enable()  { enabled = true; }
    function disable() { enabled = false; }

    function i(text) {
      if(enabled) {
          console.log("%c SCORM API: info { " + text + " }", "background-color: rgba(67, 110 238, 0.2); color: #436EEE");
      }
    }

    function s(text) {
      if(enabled) {
        console.log("%c SCORM API: success { " + text + " }", "background-color: rgba(168, 219, 168, 0.2); color: #79BD9A");
      }
    }

    function e(text) {
      if(enabled) {
        console.log("%c SCORM API: error { " + text + " }", "background-color: rgba(255, 0, 51, 0.1); color: #ff0033");
      }
    }

    this.enable = enable;
    this.disable = disable;
    this.i = i;
    this.s = s;
    this.e = e;
  }

  this.LMSInitialize = LMSInitialize;
  this.Initialize = LMSInitialize;
  this.LMSGetLastError = LMSGetLastError;
  this.GetLastError = LMSGetLastError;
  this.LMSGetErrorString = LMSGetErrorString;
  this.GetErrorString = LMSGetErrorString;
  this.LMSGetValue = LMSGetValue;
  this.GetValue = LMSGetValue;
  this.LMSSetValue = LMSSetValue;
  this.SetValue = LMSSetValue;
  this.LMSCommit = LMSCommit;
  this.Commit = LMSCommit;
  this.LMSFinish = LMSFinish;
  this.Terminate = LMSFinish;
  this.log = log;
}
